import { A4uRemove as IconComponent } from '@adobe/react-spectrum-workflow/dist/Remove.js';
import { Icon } from '@adobe/react-spectrum/Icon';
import React from 'react';
export default function Remove(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}